module.exports = __webpack_public_path__ + "img/rob.0e20d4b8.png";